import { Component, inject, OnInit } from '@angular/core';
import { UilabMatProgressSpinnerModule } from '@uilab/ng-mat-components';
import { LoginService } from 'src/app/services/login/login.service';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.page.html',
    styleUrls: ['./callback.page.scss'],
    standalone: true,
    imports: [UilabMatProgressSpinnerModule],
})
export class CallbackPage implements OnInit {
    public login = inject(LoginService);

    ngOnInit(): void {
        this.login.callback();
    }
}
